<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="header d-flex align-items-center justify-content-between">
          <h3 class="mb-0 col-4">Locations</h3>
          <div class="col-sm-6 col-md-4 col-xl-4 text-end">
            <button class="col-sm-12 col-md-4 col-xl-5 btn btn-ancotrans mb-2" (click)="downloadAuditLog()">
              Download audit log
            </button>
            <button class="col-sm-12 col-md-4 col-xl-5 btn btn-ancotrans mb-2" (click)="onCreate()">
              Create location
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="top-spacer"></div>
    <div>
      <form [formGroup]="searchForm" class="sticky-header">
        <div class="row">
          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search name</mat-label>
              <input
                autocomplete="off"
                matInput
                formControlName="searchName"
                (ngModelChange)="resetOffset()"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search street</mat-label>
              <input
                autocomplete="off"
                matInput
                formControlName="searchStreet"
                (ngModelChange)="resetOffset()"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search house number</mat-label>
              <input
                autocomplete="off"
                matInput
                formControlName="searchHouseNumber"
                (ngModelChange)="resetOffset()"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search zip</mat-label>
              <input
                matInput
                autocomplete="off"
                formControlName="searchZip"
                (ngModelChange)="resetOffset()"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search city</mat-label>
              <input
                matInput
                autocomplete="off"
                formControlName="searchCity"
                (ngModelChange)="resetOffset()"
              />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Select country code</mat-label>
              <mat-select
                (change)="resetOffset()"
                formControlName="searchCountryCode"
              >
                <mat-option
                  *ngFor="let country of countries"
                  [value]="country.code"
                >
                  {{ country.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Select result type</mat-label>
              <mat-select
                (change)="resetOffset()"
                formControlName="resultType"
                [ngClass]="{
                  'validator-error':
                    searchForm.controls['resultType'].invalid &&
                    searchForm.controls['resultType'].touched
                }"
              >
                <mat-option
                  *ngFor="let searchType of searchTypes"
                  [value]="searchType.value"
                >
                  {{ searchType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Select location type</mat-label>
              <mat-select
                (change)="resetOffset()"
                formControlName="searchAddressType"
              >
                <mat-option
                  *ngFor="let locationType of locationTypes"
                  [value]="locationType.type"
                >
                  {{ locationType.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field
              appearance="outline"
              class="datepicker-container w-100"
            >
              <mat-label>Choose from date</mat-label>
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="pickerFrom"
                formControlName="searchStartDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerFrom"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-form-field
              appearance="outline"
              class="datepicker-container w-100"
            >
              <mat-label>Choose to date</mat-label>
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="pickerTo"
                formControlName="searchEndDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerTo"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-checkbox
              [checked]="forceName"
              (change)="forceName = !forceName"
            >
              <span style="white-space: break-spaces">
                Show forced names only</span
              ></mat-checkbox
            >
          </div>

          <div class="col-md-3 col-sm-6 d-flex">
            <mat-checkbox
              data-toggle="tooltip"
              title="Filtering available on the non-validated addresses tab"
              [disabled]="tabIndexSelected == 0"
              [checked]="isCandidate"
              (change)="isCandidate = !isCandidate"
            >
              <span style="white-space: break-spaces"
                >Show only candidate addresses</span
              >
            </mat-checkbox>
          </div>
        </div>
        <div class="row p-2">
          <div class="col-12">
            <div class="row">
              <button
                (click)="getLocations()"
                class="col-sm-12 col-md-1 col-xl-1 btn btn-ancotrans mb-2"
              >
                Search
              </button>
              <button
                (click)="clearForm()"
                class="col-sm-12 col-md-1 col-xl-1 btn btn-ancotrans mb-2"
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      </form>

      <mat-tab-group
        (selectedTabChange)="tabChanged($event)"
        [(selectedIndex)]="tabIndexSelected"
        class="mt-3"
      >
        <mat-tab label="Addresses">
          <ng-container *ngTemplateOutlet="table"></ng-container>
        </mat-tab>
        <mat-tab label="Unvalidated addresses">
          <div *ngIf="tabIndexSelected == 1 && selectedCount >= 1" class="d-flex justify-content-end mb-3 mt-2">
            <button
              class="btn btn-danger me-2"
              [disabled]="isDeleting"
              (click)="deleteSelectedLocations()">
              <i class="fa fa-trash" *ngIf="!isDeleting"></i>
              <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i>
              {{ isDeleting ? 'Deleting...' : 'Selected to delete (' + selectedCount + ')' }}
            </button>
          </div>
          <ng-container *ngTemplateOutlet="table"></ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<ng-template #table>
  <table class="table table-striped">
    <thead>
      <tr>
        <th
          *ngIf="tabIndexSelected == 1"
          class="expand-column"
          scope="col"
        ></th>
        <th scope="col" class="pointer" (click)="sortLocations('type')">
          Type
          <i
            *ngIf="sortValues.type"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.type == 'asc',
              'fa-arrow-up': sortValues.type == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('address')">
          Address
          <i
            *ngIf="sortValues.address"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.address == 'asc',
              'fa-arrow-up': sortValues.address == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('houseNumber')">
          House number
          <i
            *ngIf="sortValues.houseNumber"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.houseNumber == 'asc',
              'fa-arrow-up': sortValues.houseNumber == 'desc'
            }"
          ></i>
        </th>

        <th scope="col" class="pointer" (click)="sortLocations('name')">
          Name
          <i
            *ngIf="sortValues.name"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.name == 'asc',
              'fa-arrow-up': sortValues.name == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('zip')">
          Zip
          <i
            *ngIf="sortValues.zip"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.zip == 'asc',
              'fa-arrow-up': sortValues.zip == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('city')">
          City
          <i
            *ngIf="sortValues.city"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.city == 'asc',
              'fa-arrow-up': sortValues.city == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('country')">
          Country
          <i
            *ngIf="sortValues.country"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.country == 'asc',
              'fa-arrow-up': sortValues.country == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('usageCount')">
          Usage count
          <i
            *ngIf="sortValues.usageCount"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.usageCount == 'asc',
              'fa-arrow-up': sortValues.usageCount == 'desc'
            }"
          ></i>
        </th>
        <th
          scope="col"
          class="pointer"
          (click)="sortLocations('score')"
          *ngIf="searchForm.controls['resultType'].value == 'automatic'"
        >
          Score
          <i
            *ngIf="sortValues.score"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.score == 'asc',
              'fa-arrow-up': sortValues.score == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" class="pointer" (click)="sortLocations('createdAt')">
          Created at
          <i
            *ngIf="sortValues.createdAt"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.createdAt == 'asc',
              'fa-arrow-up': sortValues.createdAt == 'desc'
            }"
          ></i>
        </th>
        <th scope="col"></th>
        <th scope="col" class="pointer" (click)="sortLocations('lastUsedAt')">
          Last used
          <i
            *ngIf="sortValues.lastUsedAt"
            class="fa"
            [ngClass]="{
              'fa-arrow-down': sortValues.lastUsedAt == 'asc',
              'fa-arrow-up': sortValues.lastUsedAt == 'desc'
            }"
          ></i>
        </th>
        <th scope="col" align="right">Actions</th>
        <th *ngIf="tabIndexSelected == 1" scope="col" class="checkbox-column text-center">
          <mat-checkbox
            [checked]="isAllSelected"
            [indeterminate]="selectedLocationIds.size > 0 && !isAllSelected"
            (change)="toggleAllSelection()"
            [disabled]="isDeleting">
          </mat-checkbox>
        </th>
      </tr>
    </thead>
    <tbody>
      <div *ngIf="loading" class="d-table-row table-spiner">
        <ngx-spinner [fullScreen]="false"> </ngx-spinner>
      </div>
      <ng-container *ngIf="!loading && locationContent">
        <ng-container
          *ngFor="let location of locationContent.content; trackBy: trackById"
        >
          <tr scope="row" (click)="toggleRow(location.extras.geodata_id)">
            <td class="expand-column" *ngIf="tabIndexSelected == 1">
              <span
                *ngIf="
                  location.extras.geodata_id === expandedRowIndex;
                  else down
                "
                ><mat-icon>expand_less</mat-icon></span
              >
              <ng-template #down>
                <mat-icon>expand_more</mat-icon>
              </ng-template>
            </td>
            <td>{{ location.location?.type }}</td>
            <td>
              {{ location.address?.street }} {{ location.address?.street2 }}
            </td>
            <td>{{ location.address?.house_no }}</td>
            <td>{{ location.address?.name }} {{ location.address?.name2 }}</td>
            <td>{{ location.address?.zip }}</td>
            <td>{{ location.address?.city }}</td>
            <td>{{ location.address?.country?.code }}</td>
            <td>{{ location.extras?.usage_count }}</td>
            <td *ngIf="searchForm.controls['resultType'].value == 'automatic'">
              {{ location.score }}
            </td>
            <td>
              {{ location.extras?.created_on | date : "dd LLLL yyyy HH:mm" }}
            </td>
            <td style="padding-top: 5px">
              <avatar
                [username]="
                  location.extras?.modified_by ?? location.extras?.created_by
                "
              ></avatar>
            </td>
            <td>
              {{ location.extras?.last_used | date : "dd LLLL yyyy HH:mm" }}
            </td>
            <td align="right">
              <button
                *ngIf="location.extras?.geodata_id"
                (click)="onEdit(location); $event.stopPropagation()"
                class="btn btn-ancotrans"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-danger" (click)="onDelete(location); $event.stopPropagation()">
                <i class="fa fa-remove"></i>
              </button>
            </td>
            <td *ngIf="tabIndexSelected == 1" class="checkbox-column text-center" (click)="$event.stopPropagation()">
              <mat-checkbox
                [checked]="selectedLocationIds.has(location.extras.geodata_id)"
                (change)="toggleLocationSelection(location.extras.geodata_id, $event)"
                [disabled]="isDeleting">
              </mat-checkbox>
            </td>
          </tr>

          <tr
            [@openClose]="isOpen ? 'open' : 'closed'"
            *ngIf="expandedRowIndex === location.extras.geodata_id"
            class="table-expanded-row"
          >
            <td [colSpan]="100">
            
              <address-validation-detail
                [location]="location"
                [suggestedData]="suggestedDataChange">
              </address-validation-detail>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>

  <paging
    [offset]="offset"
    [limit]="limit"
    [itemsLength]="totalCount"
    (pageChanged)="pageChanged($event)"
  ></paging>
</ng-template>
